import { Icon, InputV2 } from "@southfields-digital/mxmz-react-ui";
import { useState } from "react";
import { sticky } from "tippy.js";

import { Tooltip } from "../Tooltip";

import CanvasOutputPickerOverlay from "./CanvasOutputPickerOverlay";
import type { CanvasOutputPickerProps } from "./types";
import { useCanvasOutputPicker } from "./useCanvasOutputPicker";

export default function CanvasOutputPicker({
	graphic,
	playlistGraphicId,
	canvasOverride,
	onUpdate,
	isLive = false,
}: CanvasOutputPickerProps) {
	const [isOverlayOpen, setIsOverlayOpen] = useState(false);

	const { options, selectedIds, hasOverride, buttonText, handleToggle, handleReset } =
		useCanvasOutputPicker({ graphic, playlistGraphicId, canvasOverride, onUpdate });

	return (
		<Tooltip
			overlay={
				<CanvasOutputPickerOverlay
					graphic={graphic}
					options={options}
					selectedIds={selectedIds}
					hasOverride={hasOverride}
					readOnly={isLive}
					onToggle={handleToggle}
					onReset={handleReset}
				/>
			}
			interactive
			trigger="click"
			placement="bottom-end"
			sticky
			plugins={[sticky]}
			className="!bg-input-dark rounded border border-gray-50/15 shadow-[0px_0px_12px_0px_rgba(0,0,0,0.4)] !p-0 -mt-1.5"
			appendTo={document.body}
			onShow={() => setIsOverlayOpen(true)}
			onHide={() => setIsOverlayOpen(false)}
			duration={0}
		>
			<div
				// Wrapper needed so the chevron icon stays clickable
				onClick={(e) => {
					e.stopPropagation();
					e.preventDefault();
				}}
			>
				<InputV2
					readOnly
					inputSize="sm"
					value={buttonText}
					className="cursor-pointer select-none text-ellipsis"
					wrapperClassName="!cursor-pointer !gap-0"
					onClick={(e) => {
						e.stopPropagation();
						e.preventDefault();
					}}
					suffix={
						<Icon
							icon={isOverlayOpen ? "chevron-up" : "chevron-down"}
							size={12}
							className="pointer-events-none"
						/>
					}
				/>
			</div>
		</Tooltip>
	);
}
